import { useEffect, useEffectEvent, useState } from 'react';
import { useParams } from 'react-router';
import { useQuery } from '@apollo/client/react';

import AccountDescriptions from './AccountDescriptions';
import { CUSTOMER_BANKRUPTCY_LEGAL_INFO } from 'queries/bankruptcy';
import { BANKRUPTCY_CHAPTER } from 'utilities/constants';
import { formatDate } from 'utilities/datesAndTimes';

const BankruptcyLegalDescriptions = () => {
  const { customerId, accountId } = useParams();

  const { data } = useQuery(CUSTOMER_BANKRUPTCY_LEGAL_INFO, {
    variables: { customerId, creditAccountIds: [accountId] },
  });

  const bankruptcyLegalInfo =
    data?.customer?.creditAccounts?.[0]?.bankruptcyLegalInfo;

  const items = [];
  const chapter = bankruptcyLegalInfo?.chapter;
  if (bankruptcyLegalInfo && chapter !== BANKRUPTCY_CHAPTER.CHAPTER_128) {
    items.push(
      {
        key: 1,
        span: 2,
        label: 'Filing Stage',
        children: (
          <span data-testid="bankruptcy-filing-stage">
            {bankruptcyLegalInfo.stage}
          </span>
        ),
      },
      {
        key: 2,
        span: 2,
        label: 'Chapter',
        children: (
          <span data-testid="bankruptcy-chapter">
            {bankruptcyLegalInfo.chapter}
          </span>
        ),
      },
      {
        key: 3,
        span: 2,
        label: 'Case Number',
        children: (
          <span data-testid="bankruptcy-case-number">
            {bankruptcyLegalInfo.caseNumber}
          </span>
        ),
      },
      {
        key: 4,
        span: 2,
        label: 'Filing Date',
        children: (
          <span data-testid="bankruptcy-filing-date">
            {formatDate(bankruptcyLegalInfo.dateFiled)}
          </span>
        ),
      },
    );

    if (bankruptcyLegalInfo.withdrawnDismissedDate) {
      items.push({
        key: 5,
        span: 2,
        label: 'Dismissal Date',
        children: (
          <span data-testid="bankruptcy-dismissal-date">
            {formatDate(bankruptcyLegalInfo.withdrawnDismissedDate)}
          </span>
        ),
      });
    }
  }

  if (items.length === 0) {
    return null;
  }

  return <AccountDescriptions title="Bankruptcy Legal Info" items={items} />;
};

export default BankruptcyLegalDescriptions;
